import { en as authEn } from './auth/locales/en';
import { pt as authPt } from './auth/locales/pt';

import { en as entitiesEn } from './entities/locales/en';
import { pt as entitiesPt } from './entities/locales/pt';

import { en as rolesEn } from './roles/locales/en';
import { pt as rolesPt } from './roles/locales/pt';

import { en as rulesEn } from './rules/locales/en';
import { pt as rulesPt } from './rules/locales/pt';

import { en as usersEn } from './users/locales/en';
import { pt as usersPt } from './users/locales/pt';

import { en as terminalsEn } from './terminals/locales/en';
import { pt as terminalsPt } from './terminals/locales/pt';

import { en as interfacesEn } from './interfaces/locales/en';
import { pt as interfacesPt } from './interfaces/locales/pt';

import { en as entityInterfacesEn } from './entityInterfaces/locales/en';
import { pt as entityInterfacesPt } from './entityInterfaces/locales/pt';

import { en as sharedEn } from './shared/locales/en';
import { pt as sharedPt } from './shared/locales/pt';

import { en as dashboardEn } from './dashboard/locales/en';
import { pt as dashboardPt } from './dashboard/locales/pt';

import { en as otherEntitiesEn }from '../smartBuildings/locales';
import { pt as otherEntitiesPt } from '../smartBuildings/locales';

import {en as notFoundEn} from './notFound/locales/en';
import {pt as notFoundPt} from './notFound/locales/pt';

export const en = {
    ...authEn,
    ...entitiesEn,
    ...usersEn,
    ...rolesEn,
    ...rulesEn,
    ...sharedEn,
    ...terminalsEn,
    ...interfacesEn,
    ...otherEntitiesEn,
    ...dashboardEn,
    ...entityInterfacesEn,
    ...notFoundEn
};

export const pt = {
    ...authPt,
    ...entitiesPt,
    ...usersPt,
    ...rolesPt,
    ...rulesPt,
    ...sharedPt,
    ...terminalsPt,
    ...interfacesPt,
    ...otherEntitiesPt,
    ...dashboardPt,
    ...entityInterfacesPt,
    ...notFoundPt
};